import { render } from "./StonesFormStep3.vue?vue&type=template&id=6d29d46a&scoped=true&lang=html"
import script from "./StonesFormStep3.vue?vue&type=script&lang=js"
export * from "./StonesFormStep3.vue?vue&type=script&lang=js"

import "./StonesFormStep3.vue?vue&type=style&index=0&id=6d29d46a&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d29d46a"]])

export default __exports__